export const intercomArticleIds = {
  FORMULA_EDITOR_GUIDE: "14019268",
  FUNDRAISING: "9938229",
  DOCUMENT_ACTIVITY: "9734254",
  PORTAL_ACCESS_PANEL: "16415402",
  MANAGE_PORTAL_USER_ACCESS: "7832679",
  INVESTOR_PORTAL_FOR_LPS: "9116080",
  REGISTRATION_BY_EMAIL: "15693089",
  IMPERSONATE_CONTACT: "9173563",
  MFA: "9778164",
  INVESTOR_DOCUMENT_BLOCKED_BY_NETWORK: "16498940",
};
